import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.NetSuiteRequestCard.NetSuiteLink', {
    openInNetSuiteLinkText: 'Open in NetSuite',
});
